import { Inject, Injectable } from '@angular/core';
import { getApp } from '@angular/fire/app';
import { getDownloadURL, getStorage, ref, Storage, uploadBytes } from '@angular/fire/storage';

@Injectable({
  providedIn: 'root',
})
export class FirebaseStorageService {
  private storage: Storage;

  constructor(
    @Inject('appName') protected appName?: string,
  ) {
    this.storage = getStorage(getApp(appName));
  }

  async uploadBase64(base64Data: string, path: string, contentType: string): Promise<void> {
    const response = await fetch(base64Data);
    const blob = await response.blob();
    const storageRef = ref(this.storage, path);
    await uploadBytes(storageRef, blob, { contentType });
  }

  async uploadFile(file: File, path: string): Promise<string> {
    const storageRef = ref(this.storage, path);
    const snapshot = await uploadBytes(storageRef, file);
    return getDownloadURL(snapshot.ref);
  }
}
